import {
  getWritingCompanionClassroomAccess,
  isWritingCompanionPolicyEnabled,
} from "~/utils/writing-companion-purchase";

export const useStudentWritingToolsAccess = (documentId: string) => {
  const submittedDocumentStore = useSubmittedDocumentStore(documentId);
  const { submittedDocument } = storeToRefs(submittedDocumentStore);
  const documentClassroomDataStore = useDocumentClassroomDataStore(documentId);
  const { classroom } = storeToRefs(documentClassroomDataStore);

  const entitlementClassroomId = computed(() =>
    isWritingCompanionPolicyEnabled(
      classroom.value?.writingCompanionPolicy ??
        classroom.value?.writingCompanionPurchasePolicy
    )
      ? submittedDocument.value?.classroomId
      : undefined
  );

  const {
    hasPurchased,
    isLoading,
    status,
  } = useStudentWritingCompanionEntitlement(
    () => submittedDocument.value?.studentId,
    entitlementClassroomId
  );

  const legacyCanUseThesaurus = computed(() => {
    const currentDocument = submittedDocument.value;
    const currentClassroom = classroom.value;
    if (!currentDocument) return false;

    if (!currentClassroom) {
      return currentDocument.enableStudentThesaurus == true;
    }

    return (
      currentClassroom.enableStudentThesaurus == true &&
      currentDocument.studentId != undefined &&
      currentClassroom.studentThesaurusStudentIds.includes(
        currentDocument.studentId
      )
    );
  });

  const access = computed(() =>
    getWritingCompanionClassroomAccess({
      policy:
        classroom.value?.writingCompanionPolicy ??
        classroom.value?.writingCompanionPurchasePolicy,
      hasPurchased: hasPurchased.value,
      isLoading: isLoading.value,
      isActivationPending: status.value === "activationPending",
      isVerificationUnavailable: status.value === "verificationUnavailable",
      legacyCanRunChecklist:
        submittedDocument.value?.enableStudentReview == true,
      legacyCanUseThesaurus: legacyCanUseThesaurus.value,
      legacyEnabled: classroom.value?.enableStudentSubmissionCreation,
      legacyStudentIds:
        classroom.value?.studentSubmissionCreationStudentIds ?? [],
      studentId: submittedDocument.value?.studentId,
    })
  );

  const isAccessLoading = computed(
    () =>
      isLoading.value &&
      (submittedDocument.value?.enableStudentReview != true ||
        legacyCanUseThesaurus.value != true)
  );

  return {
    access: readonly(access),
    isAccessLoading: readonly(isAccessLoading),
  };
};
